export const tabsEnum = {
	OVERVIEW: "overview",
	DETAILS: "details",
};

Object.freeze(tabsEnum);

export const tabsArray = Object.values(tabsEnum);
